import { render, staticRenderFns } from "./Products.vue?vue&type=template&id=d470bdb4&scoped=true&"
import script from "./Products.vue?vue&type=script&lang=js&"
export * from "./Products.vue?vue&type=script&lang=js&"
import style0 from "./Products.vue?vue&type=style&index=0&id=d470bdb4&scoped=true&lang=stylus&"
import style1 from "./Products.vue?vue&type=style&index=1&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d470bdb4",
  null
  
)

component.options.__file = "Products.vue"
export default component.exports